import { FC } from "react";

// Images
import homeLocationA from "../../../assets/img/HomePage/Desktop/home_location_a.jpg";
import homeLocationB from "../../../assets/img/HomePage/Desktop/home_location_b.jpg";
import homeLocationC from "../../../assets/img/HomePage/Desktop/home_location_c.jpg";

import { ReactComponent as LocationIconFilled } from "../../../icons/LocationIconFilled.svg";

const HomeLocations = () => {
  return (
    <section className="pl-[120px] h-[790px]">
      <div className="relative z-10 w-full h-full">
        <div className="relative top-0 right-0 bg-[#F8F8F8] w-full h-[532px] pl-[80px] py-[100px]">
          <div className="bg-text-1000 px-[50px] py-[40px] rounded-l-[16px] shadow-xl shadow-text-0/24">
            {/* Heading */}
            <h3 className="text-[36px] font-raleway font-semibold text-primaryDark-0 leading-tight mb-[36px]">
              <span className="text-primaryDark-400"> Available </span>{" "}
              Locations
            </h3>

            {/* Image Grid */}
            <HomeLocationsImageGrid />
          </div>
        </div>
      </div>
    </section>
  );
};

const HomeLocationsImageGrid = () => {
  return (
    <div className="flex items-center justify-between gap-[24px]">
      <HomeLocationsImageGridItem
        imageSrc={homeLocationA}
        imgLocation="Washington D.C."
      />
      <HomeLocationsImageGridItem
        imageSrc={homeLocationB}
        imgLocation="Maryland"
      />
      <HomeLocationsImageGridItem
        imageSrc={homeLocationC}
        imgLocation="Northern Virginia"
      />
    </div>
  );
};

type HomeLocationsImageGridItemProps = {
  imageSrc: string;
  imgLocation: string;
};

const HomeLocationsImageGridItem: FC<HomeLocationsImageGridItemProps> = ({
  imageSrc,
  imgLocation,
}) => {
  return (
    <div className="rounded-[8px] p-[10px] bg-[#F8F8F8] flex items-center justify-center cursor-pointer">
      <div className="rounded-[8px] relative">
        {/* Image Box */}
        <img
          src={imageSrc}
          alt="location"
          className="w-full h-full object-center rounded-[8px]"
        />

        {/* Location Box */}
        <div className="absolute z-10 bottom-[16px] right-[16px] p-[8px] bg-text-1000/20 rounded-[32px]">
          <div className="px-[20px] py-[10px] flex items-center gap-[8px] bg-text-1000 rounded-[32px]">
            <LocationIconFilled className="text-primaryDark-400 w-[20px] h-[20px]" />
            <p className="text-[14px] font-raleway font-bold text-text-0">
              {imgLocation}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeLocations;
